export const EmbeddedRental = () => (
    <iframe
        src='https://rental.logistic-network.rio.cloud/#/support'
        title='Rental support'
        className={'unstyled full-window'}
        allow={'clipboard-write'}
    />
);
